<template>
    <div>
        <div class="btn">
            <!-- <button @click="showModal">{{buttonName}}</button> -->
        </div>

       <modal v-show="show" :title="buttonName" @close="close" @confirm="confirm">
             <template v-slot:formData>
                <el-form ref="form"  label-width="100px">
                    <el-form-item label="标题内容">
                        <el-input placeholder="请输入标题内容" v-model="form.title" @blur.native.capture="cleanData()"></el-input>
                    </el-form-item>

                    <el-form-item label="提问人员">
                        <el-input placeholder="请输入姓名" v-model="form.name"></el-input>
                    </el-form-item>

                    <el-form-item label="手机号码">
                        <el-input placeholder="请输入手机号码" v-model="form.mobile"></el-input>
                    </el-form-item>

                    <el-form-item :label="buttonName">
                        <el-input type="textarea" placeholder="请输入内容" v-model="form.content"></el-input>
                    </el-form-item>

                    <el-form-item label="验证码" style="text-align:left">
                        <el-input placeholder="请输入验证码" v-model="form.checkCode" style="width:490px"></el-input>
                        <label 
                        style="float:right;font-size:20px;height:50px;line-height:50px;color:#ccc;cursor:pointer"
                        @click="getCode"
                        >
                            {{code}}
                        </label>
                    </el-form-item>
                </el-form>
             </template>
       </modal>

        <div id="q" >
            <div v-for="(item,index) in data" :key="index">
                <div class="question">
                    <div style="width:25px">
                        <i class="el-icon-edit"></i>
                    </div>

                    <div style="width:1030px">
                        {{item.content}}
                    </div>
                
                    <div class="time">
                        {{item.createDate | datetime}}
                    </div>

                </div>

                <div class="answer">
                    <div>
                        <strong>回答:</strong>
                    </div>
                    <div>
                        {{item.replyContent}}
                    </div>
                </div>
            </div>
        </div>

        <div id="page">
             <el-pagination
                background
                layout="prev, pager, next"
                @current-change="handleCurrentChange"
                :total="total"
                :page-size="pageSize">
            </el-pagination>
         </div>
    </div>
</template>

<script>
    import PortalApi from "@/api/portal/index";
    import Modal from "./Modal.vue"
    export default{
        props:{
            buttonName:{
                type:String,
                default:""
            },
            type:{  // 类别：咨询 0 or 投诉 1
                type:String,
                default:"1"
            }
        },
        components:{
            modal:Modal
        },
        activated(){
            this.getCode();
            PortalApi.getConsultContent(0,this.pageSize,this.type)
                .then(
                    res=>{
                        this.data = res.data;
                        this.total = res.count;
                    }
                )
        },
        data(){
            return{
            imgList:{
                1:"static/img/banner.34ecf2a8.png",
            },
            total:0,
            currentPage:0,
            pageSize:5,
            data:[],
            show:false,
            form:{
                title:"",
                name:"",
                mobile:"",
                content:"",
                checkCode:"",
                type:0
            },
            code:"",
            // contentName:""
            }
        },
        methods:{
             handleCurrentChange(page){
                PortalApi.getConsultContent(page,this.pageSize,this.type)
                .then(
                    res=>{
                        this.data = res.data;
                        this.total = res.count;
                    }
                )
            },
            showModal(){
                this.getCode();
                this.show = true;
               
            },
            close(){
                this.show = false;
            },
            confirm(){
                if(this.form.title.trim()==""){
                    this.$message('请输入标题内容');
                    return false;
                }
                if(this.form.name.trim()==""){
                    this.$message('请输入姓名');
                    return false;
                }
                if(this.form.mobile.trim()==""){
                    this.$message('请输入手机号码');
                    return false;
                }
                if(this.form.content.trim()==""){
                    this.$message('请输入内容');
                    return false;
                }
                if(this.form.checkCode!=this.code){
                    this.$message('验证码错误');
                    return false;
                }

                PortalApi.subConsultContent(this.form)
                .then(
                    ()=>{
                        this.show = false;
                    }
                )
            },
            getCode(){
                var codeChars=[0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
                var len = codeChars.length;
                this.code = "";
                for(var i=0;i<5;i++){
                    var randomIndex = Math.floor(Math.random() * len);
                    this.code += codeChars[randomIndex];
                }
            },
            cleanData(){
                // 清楚非法字符
                this.form.title = this.form.title.replace(/\|&;\$%@"<>\(\)\+,/g, "");
            }
        },
        watch:{
            type(newVal){
                this.form.type = newVal;
                PortalApi.getConsultContent(0,this.pageSize,newVal)
                .then(
                    res=>{
                        this.data = res.data;
                        this.total = res.count;
                    }
                )
            }
        }
    }
</script>

<style lang="scss" scoped>
    .btn{
        text-align: right;
    }
    button{
        width: 200px;
        height: 50px;
        color:white;
        font-size: 20px;
        font-weight: bold;
        background:#ff4200;
        border: none;
        outline: none;
        border-radius: 25px;
    }
     #q{
        padding-top: 10px;
        text-align: left;
    }
    .time{
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
    }
    .question{
        line-height: 22px;
        font-size: 18px;
        font-weight: bold;
        color:#575757;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        padding-top: 15px;
        padding-bottom: 15px;
        position: relative;
    }
    /* .question div:nth-child(2){
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    } */
    .question i{
        color:red;
    }
    .answer{
        color:#767676;
        padding:40px 25px;
        background-color: #f7f7f7;
    }
    #page{
        margin: 40px auto;
    }
    strong{
        color:#565656;
        font-size: 16px;
    }
    .el-form-item__content{
        width: 550px;
    }
</style>